<template>
  <div class="container user-edit mt-5">
    <loading-screen v-show="isLoading" :content="loadingScreenContent" />
    <div v-show="!isLoading">
      <div class="content-box">
        <div class="mb-3 text-center">
          <h1
            class="text-center"
            :class="selectedTitle.class"
            :style="{ ...selectedTitle.style, color: partnerColor }"
          >
            {{ selectedTitle.text }}
          </h1>
          <h4
            class="text-center"
            :class="selectedSubTitle.class"
            :style="selectedSubTitle.style"
          >
            {{ selectedSubTitle.text }}
          </h4>
        </div>
        <user-details-form-fields
          :isLoading="isLoading"
          @loadingScreen="loadingScreen"
        />
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import UserDetailsFormFields from '@/components/UserDetailsFormFields.vue';
import LoadingScreen from "@/components/LoadingScreen.vue";

export default {
  name: 'UserDetails',

  components: {
    LoadingScreen,
    UserDetailsFormFields
  },

  data() {
    return {
      selectedTitle: '',
      selectedSubTitle: '',
      isLoading: false,
      contactCount: 0,
      conditionalDisplay: false,
    }
  },

  created() {
    this.selectedTitle = this.settings.attributes.title;
    this.selectedSubTitle = this.settings.attributes.subtitle;
  },

  computed: {
    partner() {
      return this.$store.state.partners.currentPartner;
    },

    settings() {
      return this.partner.settings.sections.user_details_page;
    },

    partnerColor() {
      const el = document.createElement('span');
      el.className = 'egx-partner-color';
      document.body.appendChild(el);
      const color = this.partner.settings.sections.custom_css["--egx-partner-color"]
      document.body.removeChild(el);
      return color;
    },

    loadingScreenContent() {
      return this.settings?.loading_screen || {
        title: {
          text: 'Adding your account',
          class: ['egx-partner-color'],
          style: 'color: var(--egx-partner-color)',
        },
        description: {
          text: 'Please wait while we update your account details.'
        },
        spinner:{
          class: ['egx-partner-color']
        },
        cta: {
          text: 'If this page doesn\'t refresh, please try again.',
          class: ['egx-partner-color'],
          path_name: 'home'
        }
      }
    },
    currentUser() {
      return this.$store.state.users.currentUser;
    },
  },

  methods: {
    loadingScreen(val){
      this.isLoading = val;
    },
  },
};
</script>

<style scoped>
</style>
